import { Action, Dispatch } from 'redux';
import { IAppState } from '../reducers';
import {
  ActionType as FormAction,
  updateFormType, FormType,
  updateSelectedSchedule,
} from './gameScheduleForm';
import { getScheduleById } from '../../api/vault/exchangeSchedule';
import { getTeamById } from '../../api/vault/teams';

export interface IState {
  isOpen: boolean;
}

export enum ActionType {
  Toggle = 'GameScheduleDialog.Toggle',
  ClearAll = 'GameScheduleDialog.ClearAll',
}

export interface IUpdateAssetGameScheduleDialogAction extends Action<ActionType> {
  payload?: any;
}

const INITIAL_STATE: IState = {
  isOpen: false,
};

export default function reducer(state: IState = INITIAL_STATE, action: IUpdateAssetGameScheduleDialogAction): IState {
  switch (action.type) {
    case ActionType.Toggle:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case ActionType.ClearAll:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
}

export const toggleUpdateAssetGameScheduleDialog = (scheduleId: string) => async (dispatch: Dispatch, getState: () => IAppState) => {
  const {
    exchange: {
      updateAssetGameScheduleDialog: {
        isOpen,
      },
    },
  } = getState();
  if (!isOpen) {
    dispatch(updateFormType(FormType.UpdateAssets));
    const res = await getScheduleById(scheduleId);
    const schedule = res?.data?.data;
    const homeTeam = (await getTeamById(schedule?.HomeTeamId)).data?.data;
    const awayTeam = (await getTeamById(schedule?.VisitorTeamId)).data?.data;
    updateSelectedSchedule(schedule, { homeTeam, awayTeam })(dispatch, getState);
  }
  dispatch({ type: ActionType.Toggle });
};

export const clearAll = () => (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  dispatch({ type: FormAction.ClearAll });
  dispatch({ type: ActionType.ClearAll });
};
